import debounce from "lodash/debounce";
import WindowMode from "@/constants/WindowMode";

const WINDOW_VISIBILITY_DEBOUNCE = 500;
let currentWindowMode = WindowMode.ACTIVE;
let onWindowModeChangeCallback = () => {};

const config = {
	activeInterval: 15000, // 15 seconds
	inactiveInterval: 60000, // 1 minute
	hiddenInterval: 1800000, // 30 minutes
};

/**
 * The intent here is to monitor when the window loses focus or becomes hidden.
 * If the socketMachine needs to reconnect to the server, we'll attempt to do so
 * at a shorter interval if the window is active vs inactive or hidden.
 */
const onWindowModeChangeHandler = debounce(
	function windowModeChangeHandler( { type: eventName, } ) {
		if ( eventName === "visibilitychange" ) {
			currentWindowMode = document.visibilityState === "visible" ? WindowMode.ACTIVE : WindowMode.HIDDEN;
		}

		if ( eventName === "blur" ) {
			currentWindowMode = WindowMode.INACTIVE;
		}

		if ( eventName === "focus" ) {
			currentWindowMode = WindowMode.ACTIVE;
		}
		if ( onWindowModeChangeCallback ) {
			onWindowModeChangeCallback( currentWindowMode );
		}
	},
	WINDOW_VISIBILITY_DEBOUNCE
);

[ "visibilitychange", "focus", "blur", ].forEach( eventName => {
	window.addEventListener( eventName, onWindowModeChangeHandler );
} );

export function getHeartbeatInterval() {
	// we assume the window is in the foreground/active
	let interval = config.activeInterval;

	// if the browser window has lost focus, we back off by switching to a longer interval
	if ( currentWindowMode === WindowMode.INACTIVE ) {
		interval = config.inactiveInterval;
	}

	// if the browser is hidden altogether, we *really* slow our roll by switching to the longest interval
	if ( currentWindowMode === WindowMode.HIDDEN ) {
		interval = config.hiddenInterval;
	}
	return interval;
}

export function onWindowModeChange( cb ) {
	onWindowModeChangeCallback = cb;
}



// WEBPACK FOOTER //
// ./src/api/socketAPI/windowVisibility.js